import React from "react";
import { Link } from "react-router-dom";
import SimpleBarReact from "simplebar-react";
import { Icon } from "@iconify/react";
import Brand from "../../assets/images/logoSmall.png";
const Sidebar = () => {
  const pathName = window.location.pathname;

  const paths = [
    {
      title: "Home",
      path: "/dashboard",
      icon: "fluent:home-20-regular",
    },
    {
      title: "Surveys",
      path: "/surveys",
      icon: "icon-park-solid:music-list",
    },
    {
      title: "Clients",
      path: "/clients",
      icon: "ph:users-light",
    },
    {
      title: "Users",
      path: "/users",
      icon: "ph:users-light",
    },
    {
      title: "Lookups",
      path: "/lookup",
      icon: "gg:notes",
    },
    {
      title: "Templates",
      path: "/templates",
      icon: "heroicons:document-text",
    },
  ];
  return (
    <SimpleBarReact className="sidebar">
      <div className="brand">
        <Link to="#">
          <img src={Brand} alt="" />{" "}
        </Link>
      </div>
      <ul className="sidebarMenu">
        {paths.map((path) => (
          <li
            key={path.title}
            className={pathName === path.path ? "active" : ""}
          >
            <Link to={path.path} className="navLink">
              <i>
                <Icon icon={path.icon} />
              </i>
              <span>{path.title}</span>
            </Link>
          </li>
        ))}
      </ul>
    </SimpleBarReact>
  );
};

export default Sidebar;
